import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { Client } from '../../client-data/client.model';

export const UNMATCHED_PAYMENT_SCHEMA = Object.freeze({
  CLIENT_ID: '',
  TRANSACTION_GUID: '',
  TOTAL_AMOUNT: 0,
  UNMATCHED_AMOUNT: 0,
  CURRENCY_CODE: '',
  CREATED_TIMESTAMP: '',
  CLIENT: Client,
});
const RECORD = generateSchema(UNMATCHED_PAYMENT_SCHEMA);
const KEYS: any = generateKeys(UNMATCHED_PAYMENT_SCHEMA);

/**
 * This is an internal model that is use only by web client
 * We need this because it's way more useful to handle data this way
 * rather than having to map the relation between payment and client
 * every time
 */
export class UnmatchedPayment extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.CLIENT,
        value: props.get(KEYS.CLIENT) ? new Client(this.client) : null,
      },
    ]);

    return selfModel as UnmatchedPayment;
  }

  get clientId(): string {
    return this.get(KEYS.CLIENT_ID);
  }

  get transactionGuid(): string {
    return this.get(KEYS.TRANSACTION_GUID);
  }

  get totalAmount(): number {
    return this.get(KEYS.TOTAL_AMOUNT);
  }

  get unmatchedAmount(): number {
    return this.get(KEYS.UNMATCHED_AMOUNT);
  }

  get currencyCode(): string {
    return this.get(KEYS.CURRENCY_CODE);
  }

  get createdTimestamp(): string {
    return this.get(KEYS.CREATED_TIMESTAMP);
  }

  get client(): Client {
    return this.get(KEYS.CLIENT);
  }

  isPartiallyPaid(): boolean {
    return this.totalAmount - this.unmatchedAmount > 0;
  }
}
